/* SIDONIA · Anuncia gratis «Del dueño» (sections/sidonia-publish.liquid).
 * Formulario por pasos: tipo → lo básico → ficha técnica → historia → fotos → contacto.
 * Las fotos se reducen en el navegador (lado largo 2400 px, JPEG) y se suben directas a Supabase Storage con permisos
 * firmados por el motor; después se envía la solicitud (POST {motor}/api/anuncio). Lo escrito se guarda en este
 * dispositivo por si se deja a medias (las fotos no).
 */
(() => {
  if (customElements.get('sidonia-publish')) return;

  const SPECS = {
    coche: [
      ['Marca', 'text', 'Porsche'], ['Modelo', 'text', '911 SC'], ['Año', 'number', '1982'], ['Kilometraje', 'number', '128000', ' km'],
      ['Motor', 'text', '3.0 bóxer de 6 cilindros'], ['Potencia', 'number', '204', ' CV'],
      ['Cambio', ['Manual', 'Automático']], ['Combustible', ['Gasolina', 'Diésel', 'Híbrido', 'Eléctrico']],
      ['Color exterior', 'text', 'Rojo Guards'], ['Interior', 'text', 'Cuero negro'],
      ['Matrícula', ['Histórica', 'Normal', 'Extranjera', 'Sin matricular']], ['ITV', ['En vigor', 'Caducada', 'No aplica']]
    ],
    moto: [
      ['Marca', 'text', 'BMW'], ['Modelo', 'text', 'R 90 S'], ['Año', 'number', '1975'], ['Kilometraje', 'number', '42000', ' km'],
      ['Cilindrada', 'number', '900', ' cc'], ['Potencia', 'number', '67', ' CV'], ['Estilo', ['Clásica', 'Café racer', 'Scrambler', 'Deportiva', 'Custom', 'Trail', 'Naked', 'Scooter']],
      ['Color', 'text', 'Naranja Daytona'], ['Matrícula', ['Histórica', 'Normal', 'Extranjera', 'Sin matricular']], ['ITV', ['En vigor', 'Caducada', 'No aplica']]
    ],
    barco: [
      ['Astillero', 'text', 'Riva'], ['Modelo', 'text', 'Aquarama'], ['Año', 'number', '1968'], ['Eslora', 'text', '8,3', ' m'],
      ['Manga', 'text', '2,6', ' m'], ['Motor', 'text', '2 × 320 CV'], ['Horas de motor', 'number', '450', ' h'],
      ['Combustible', ['Gasolina', 'Diésel', 'Eléctrico', 'Vela']], ['Plazas', 'number', '8'], ['Amarre', 'text', 'Puerto de Sóller']
    ],
    casa: [
      ['Tipo', ['Casa', 'Villa', 'Finca', 'Masía', 'Cortijo', 'Piso', 'Ático']], ['Superficie construida', 'number', '320', ' m²'],
      ['Parcela', 'number', '5000', ' m²'], ['Habitaciones', 'number', '5'], ['Baños', 'number', '4'],
      ['Año de construcción', 'number', '1920'], ['Orientación', 'text', 'Sur'], ['Certificado energético', ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'En trámite']]
    ]
  };
  const esc = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const MENSAJES = {
    tipo: 'Elige si es un coche, una moto, un barco o una casa.', vendedor_tipo: 'Dinos si vendes como particular o profesional.', titulo: 'Escribe un título (marca, modelo y año).', precio: 'Revisa el precio o marca «a consultar».',
    ubicacion: 'Dinos dónde está.', resumen: 'La descripción breve necesita al menos 20 caracteres.', ficha: 'Rellena al menos 3 datos de la ficha técnica.',
    historia: 'Cuenta su historia con un poco más de detalle (mínimo 150 caracteres).', mecanica: 'Describe su mecánica y estado (mínimo 40 caracteres).',
    fotos: 'Faltan fotos.', vendedor_nombre: 'Escribe tu nombre.', telefono: 'Revisa el teléfono.', acepta_telefono: 'Necesitamos poder enseñar tu teléfono para que te contacten.',
    condiciones: 'Acepta los requisitos y las condiciones.', limite: 'Has llegado al máximo de anuncios activos a la vez. Si necesitas más, escríbenos por WhatsApp.', login: 'Tu sesión ha caducado: vuelve a entrar.',
    motor: 'El servicio de anuncios todavía no está activo. Escríbenos por WhatsApp y te lo publicamos nosotros.',
    servidor: 'Nuestro servidor ha fallado al recibir tu anuncio. No pierdes nada: vuelve a intentarlo en un rato o escríbenos por WhatsApp.',
    subida: 'No se han podido subir las fotos. Revisa la conexión y vuelve a intentarlo.', red: 'No hemos podido enviarlo. Revisa la conexión y vuelve a intentarlo.',
    clave: 'Falta un ajuste en la tienda para recibir anuncios. Escríbenos por WhatsApp y te lo publicamos nosotros mientras lo arreglamos.',
    atasco: 'No hemos podido enviar tu anuncio. Tu borrador está guardado: vuelve a intentarlo o escríbenos por WhatsApp y te lo publicamos nosotros.'
  };
  // Tiempo máximo de cada petición: si algo no responde, se avisa en vez de quedarse en «Enviando…» para siempre
  const tiempo = (ms) => (typeof AbortSignal !== 'undefined' && AbortSignal.timeout ? AbortSignal.timeout(ms) : undefined);
  const porTiempo = (e) => e && (e.name === 'TimeoutError' || e.name === 'AbortError');
  // Pasos: 0 quién eres · 1 qué vendes · 2 lo básico · 3 ficha técnica · 4 su historia · 5 fotos (y condiciones)
  const PASO_DE = { vendedor_tipo: 0, vendedor_nombre: 0, telefono: 0, acepta_telefono: 0, tipo: 1, titulo: 2, precio: 2, ubicacion: 2, resumen: 2, ficha: 3, historia: 4, mecanica: 4, fotos: 5, condiciones: 5 };
  const DRAFT = 'sidonia-publicar-borrador';
  const MAX = 30;

  const store = {
    get() { try { return JSON.parse(localStorage.getItem(DRAFT) || 'null'); } catch (e) { return null; } },
    set(v) { try { localStorage.setItem(DRAFT, JSON.stringify(v)); } catch (e) { /* sin almacenamiento */ } },
    clear() { try { localStorage.removeItem(DRAFT); } catch (e) { /* sin almacenamiento */ } }
  };

  /* Reduce una foto a JPEG con el lado largo como mucho de 2000 px (ligera: sube en segundos con el móvil) */
  async function reducir(file) {
    const max = 2000;
    let bmp;
    try { bmp = await createImageBitmap(file, { imageOrientation: 'from-image' }); } catch (e) {
      bmp = await new Promise((ok, ko) => { const i = new Image(); i.onload = () => ok(i); i.onerror = ko; i.src = URL.createObjectURL(file); });
    }
    const w = bmp.width, h = bmp.height;
    const k = Math.min(1, max / Math.max(w, h));
    const c = document.createElement('canvas');
    c.width = Math.round(w * k); c.height = Math.round(h * k);
    c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
    const blob = await new Promise((ok) => c.toBlob(ok, 'image/jpeg', 0.82));
    return { blob, w: c.width, h: c.height, url: URL.createObjectURL(blob) };
  }

  // Otras direcciones que puede tener el proxy de la app en la tienda (Shopify admin › Apps › Sidonia Platform)
  const OTRAS = ['/apps/platform', '/apps/subastas'];

  class SidoniaPublish extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.base = (this.dataset.engine || '/apps/sidonia').replace(/\/$/, '');
      this.min = Number(this.dataset.min) || 8;
      this.step = 0;
      this.photos = [];
      this.form = this.querySelector('[data-view="form"]');
      this.q = (s) => this.querySelector(s);
      this.qa = (s) => [...this.querySelectorAll(s)];
      this.q('[data-circle-link]')?.setAttribute('href', this.dataset.circleUrl);
      if (this.dataset.logged !== 'true') return this.view('login');
      // Vuelta del envío por el formulario de contacto de Shopify (cuando el motor no lo pudo recibir): ya está
      if (this.q('[data-posted]') || /[?&]contact_posted=true/.test(location.search)) {
        store.clear();
        this.q('[data-done-text]').textContent = 'Tenemos tu anuncio. Te escribimos por WhatsApp en menos de 48 horas para pedirte las fotos y publicarlo.';
        return this.view('done');
      }
      this.view('loading');
      this.init();
    }

    view(name) { this.qa('[data-view]').forEach((v) => { v.hidden = v.dataset.view !== name; }); }

    async init() {
      let mio = null;
      // ?anuncio=<id>: uno concreto de los suyos (desde «Mi perfil»); si no, el último activo
      const id = Number(new URLSearchParams(location.search).get('anuncio')) || 0;
      try {
        const r = await this.motor(id ? `anuncio?id=${id}` : 'anuncio');
        const d = await r.json();
        if (d.error === 'login') return this.view('login');
        mio = d.anuncio || null;
        this.cuenta = { activos: Number(d.activos) || 0, precio: Number(d.precio_siguiente) || 0 };
      } catch (e) { /* sin motor: se enseña el formulario y el error saldrá al enviar */ }
      if (mio && ['pendiente', 'aprobado', 'publicado'].includes(mio.estado)) return this.estado(mio);
      // ?garaje=<id>: «Ponerlo a la venta» desde Mi garaje: el formulario empieza con su coche (fotos incluidas)
      const g = Number(new URLSearchParams(location.search).get('garaje')) || 0;
      if (g) {
        try {
          const d = await (await this.motor('garaje')).json();
          this.desdeGaraje = (d.coches || []).find((c) => Number(c.id) === g) || null;
        } catch (e) { this.desdeGaraje = null; }
      }
      this.montar(mio && mio.estado === 'rechazado' ? mio : null);
    }

    /* «19,90 €» */
    euros(x) { return `${Number(x).toLocaleString('es-ES', { minimumFractionDigits: x % 1 ? 2 : 0, maximumFractionDigits: 2 })} €`; }

    estado(a) {
      this.actual = a;
      const t = {
        pendiente: ['En revisión', a.titulo, 'Lo estamos revisando. Te escribimos en menos de 48 horas.'],
        aprobado: ['Aprobado', a.titulo, 'Está aprobado: en nada lo verás publicado en Sidonia.'],
        publicado: ['Publicado', a.titulo, 'Tu anuncio ya está publicado en Sidonia.']
      }[a.estado];
      this.q('[data-status-label]').textContent = t[0];
      this.q('[data-status-title]').textContent = t[1];
      this.q('[data-status-text]').textContent = t[2];
      // Mejoras que le hemos pedido antes de publicarlo: la lista y el botón de editar bien a la vista
      let caja = this.q('[data-status-mejoras]');
      if (!caja) { caja = document.createElement('ul'); caja.dataset.statusMejoras = ''; caja.style.cssText = 'margin:1rem 0 0;padding:1rem 1rem 1rem 2.1rem;border-radius:14px;background:rgba(0,0,0,.045);display:grid;gap:.6rem;font-size:.9375rem;line-height:1.5'; this.q('[data-status-text]').after(caja); }
      const mej = Array.isArray(a.mejoras) ? a.mejoras : [];
      caja.hidden = !mej.length;
      caja.innerHTML = mej.map(([t, x]) => `<li><strong>${esc(t)}.</strong> ${esc(x)}</li>`).join('');
      if (mej.length) {
        this.q('[data-status-label]').textContent = 'Antes de publicarlo';
        this.q('[data-status-text]').textContent = 'Nos encanta tu anuncio. Para que se vea como se merece, te recomendamos estas mejoras. Edítalo cuando puedas (tus fotos y textos siguen ahí) y lo revisamos enseguida.';
      }
      const link = this.q('[data-status-link]');
      if (a.estado === 'publicado' && a.producto) { link.href = `/products/${a.producto}`; link.textContent = 'Ver mi anuncio'; link.hidden = false; }
      // Pago mensual: activar, cambiar la tarjeta o darse de baja (la página del motor, con su enlace firmado)
      let pago = this.q('[data-status-pago]');
      if (!pago && link) { pago = document.createElement('a'); pago.className = 'pb__btn pb__btn--ghost'; pago.dataset.statusPago = ''; pago.style.marginTop = '.75rem'; link.after(pago); }
      if (pago) {
        const ok = a.estado === 'publicado' && /^https:\/\//.test(a.pago_url || '');
        pago.hidden = !ok;
        if (ok) { pago.href = a.pago_url; pago.textContent = 'Pago y baja'; }
      }
      this.view('status');
      // En venta / Reservado / Vendido (solo publicado): la etiqueta que se ve en la web
      const sit = this.q('[data-situacion]');
      sit.hidden = !(a.estado === 'publicado' && a.producto);
      const marcar = (s) => this.qa('[data-sit]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.sit === s)));
      marcar(a.reservado ? 'reservado' : 'en_venta');
      if (a.reservado) this.q('[data-status-label]').textContent = 'Publicado · Reservado';
      this.qa('[data-sit]').forEach((b) => {
        b.onclick = async () => {
          const s = b.dataset.sit;
          if (b.getAttribute('aria-pressed') === 'true') return;
          if (s === 'vendido' && !confirm('¿Marcar tu anuncio como vendido? Se verá como «Vendido» en Sidonia y podrás publicar otro anuncio.')) return;
          this.qa('[data-sit]').forEach((x) => { x.disabled = true; });
          const r = await this.post('anuncio/situacion', { situacion: s, id: a.id });
          this.qa('[data-sit]').forEach((x) => { x.disabled = false; });
          if (!r.ok) { this.q('[data-status-text]').textContent = 'No hemos podido cambiarlo. Vuelve a intentarlo o escríbenos por WhatsApp.'; return; }
          if (s === 'vendido') {
            this.q('[data-done-title]').textContent = '¡Enhorabuena por la venta!';
            this.q('[data-done-text]').textContent = 'Tu anuncio se verá como «Vendido» en Sidonia. Cuando quieras, puedes publicar otro.';
            this.q('[data-done-again]').hidden = false;
            this.view('done');
            return;
          }
          marcar(s);
          this.q('[data-status-label]').textContent = s === 'reservado' ? 'Publicado · Reservado' : 'Publicado';
          this.q('[data-status-text]').textContent = s === 'reservado' ? 'Se ve como «Reservado» en Sidonia.' : 'Tu anuncio vuelve a estar en venta.';
        };
      });
      // Editar: el mismo formulario con sus datos y fotos. Si ya está aprobado o publicado, los cambios los revisamos.
      const edit = this.q('[data-status-edit]');
      edit.onclick = async () => {
        edit.disabled = true;
        edit.textContent = 'Cargando…';
        try {
          const d = await (await this.motor(`anuncio/editar?id=${a.id}`)).json();
          if (!d.ok) throw new Error(d.error);
          this.montar(null, d.anuncio);
        } catch (e) {
          edit.disabled = false;
          edit.textContent = 'Editar mi anuncio';
          this.q('[data-status-text]').textContent = 'No hemos podido abrir tu anuncio. Vuelve a intentarlo en un momento.';
        }
      };
      // Publicar otro: el formulario vacío (desde el segundo, de pago)
      const otro = this.q('[data-status-new]');
      if (otro) otro.onclick = () => { history.replaceState(null, '', location.pathname + location.search.replace(/[?&]anuncio=\d+/, '').replace(/^&/, '?')); this.montar(null); this.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
      const mas = this.q('[data-status-more]');
      if (mas && this.cuenta?.precio) { mas.textContent = `Cada anuncio más: ${this.euros(this.cuenta.precio)} al mes, con tarjeta y sin permanencia.`; mas.hidden = false; }
      // Eliminar: deja de verse en Sidonia
      const del = this.q('[data-status-delete]');
      del.onclick = async () => {
        if (!confirm('¿Eliminar tu anuncio? Dejará de verse en Sidonia y podrás publicar otro.')) return;
        del.disabled = true;
        const r = await this.post('anuncio/eliminar', { id: a.id });
        if (!r.ok) {
          del.disabled = false;
          this.q('[data-status-text]').textContent = 'No hemos podido eliminarlo. Vuelve a intentarlo o escríbenos por WhatsApp.';
          return;
        }
        store.clear();
        this.q('[data-done-title]').textContent = 'Anuncio eliminado';
        this.q('[data-done-text]').textContent = 'Ya no se ve en Sidonia. Cuando quieras, puedes publicar otro.';
        this.q('[data-done-again]').hidden = false;
        this.view('done');
      };
    }

    montar(rechazado, editar = null) {
      const f = this.form;
      this.view('form');
      this.editar = editar;
      // Datos de la cuenta
      if (this.dataset.name) f.vendedor_nombre.value = this.dataset.name;
      if (this.dataset.phone) f.telefono.value = this.dataset.phone;
      // Editando su anuncio: sus datos y sus fotos (sin el borrador)
      if (editar) this.rellenarEdicion(editar);
      // Uno nuevo cuando ya tiene otro activo: es de pago, se le dice antes de empezar
      const nota = this.q('[data-pago-nota]');
      if (nota) {
        nota.hidden = Boolean(editar) || !(this.cuenta?.activos > 0 && this.cuenta?.precio);
        if (!nota.hidden) nota.textContent = `Ya tienes ${this.cuenta.activos === 1 ? 'un anuncio' : `${this.cuenta.activos} anuncios`} en Sidonia: este cuesta ${this.euros(this.cuenta.precio)} al mes. Lo revisamos y, al publicarlo, te mandamos el enlace para pagarlo con tarjeta. Sin permanencia.`;
      }
      // Borrador
      const b = editar ? null : store.get();
      if (b) {
        Object.entries(b.campos || {}).forEach(([k, v]) => {
          const el = f.elements[k];
          if (!el) return;
          if (el instanceof RadioNodeList) { [...el].forEach((r) => { r.checked = r.value === v; }); } else if (el.type === 'checkbox') el.checked = Boolean(v); else el.value = v;
        });
        this.specsGuardadas = b.specs || {};
        this.q('[data-saved]').hidden = false;
      }
      // Desde Mi garaje: su coche (tipo, título, historia y fotos), si no hay un borrador a medias
      const c = editar || b ? null : this.desdeGaraje;
      if (c) {
        [...f.elements.tipo].forEach((r) => { r.checked = r.value === c.tipo; });
        f.titulo.value = c.titulo || '';
        f.historia.value = c.historia || '';
        if (c.mods && f.mecanica) f.mecanica.value = c.mods;
        this.specsGuardadas = { Marca: c.marca, Modelo: c.modelo, ...(c.anio ? { 'Año': String(c.anio) } : {}) };
        this.photos = (c.rutas || []).map((ruta, i) => ({ ruta, url: (c.fotos || [])[i] }));
      }
      if (rechazado) this.error(`No pudimos publicar «${rechazado.titulo}»${rechazado.nota ? `: ${rechazado.nota}` : ''}. Puedes enviar otro.`);
      this.q('[data-editing]').hidden = !editar;
      this.q('[data-send]').textContent = editar ? 'Guardar cambios' : 'Enviar mi anuncio';
      if (this.montado) {
        this.tipo();
        this.contar();
        this.fotos();
        this.ir(0, false);
        return;
      }
      this.montado = true;

      f.addEventListener('change', (e) => { if (e.target.name === 'tipo') this.tipo(); if (e.target.name === 'vendedor_tipo') this.quien(); this.guardar(); });
      f.addEventListener('input', (e) => { this.contar(); this.guardar(); e.target.closest('.pb__f')?.classList.remove('is-bad'); });
      f.precio_consultar.addEventListener('change', () => { f.precio.disabled = f.precio_consultar.checked; });
      f.precio.disabled = f.precio_consultar.checked;
      f.precio.addEventListener('input', () => { const n = f.precio.value.replace(/\D/g, ''); f.precio.value = n ? Number(n).toLocaleString('es-ES') : ''; });
      this.q('[data-next]').addEventListener('click', () => this.ir(this.step + 1));
      this.q('[data-back]').addEventListener('click', () => this.ir(this.step - 1));
      f.addEventListener('submit', (e) => { e.preventDefault(); this.enviar(); });

      // Fotos
      const input = this.q('[data-files]');
      input.addEventListener('change', () => { this.anadir([...input.files]); input.value = ''; });
      const drop = this.q('[data-drop]');
      ['dragenter', 'dragover'].forEach((t) => drop.addEventListener(t, (e) => { e.preventDefault(); drop.classList.add('is-over'); }));
      ['dragleave', 'drop'].forEach((t) => drop.addEventListener(t, (e) => { e.preventDefault(); drop.classList.remove('is-over'); }));
      drop.addEventListener('drop', (e) => this.anadir([...e.dataTransfer.files]));

      this.tipo();
      this.quien();
      this.contar();
      this.fotos();
      this.voz();
      this.ir(0, false);
      this.cargarPerfil();
    }

    /* «¿Quién eres?»: el texto cambia si es particular o empresa */
    quien() {
      const pro = this.form.vendedor_tipo.value === 'profesional';
      // El nombre de pila de su cuenta no vale como nombre de empresa (y vuelve si cambia a particular)
      const nombre = this.form.vendedor_nombre;
      if (pro && this.dataset.name && nombre.value.trim() === this.dataset.name) nombre.value = '';
      if (!pro && !nombre.value.trim() && this.dataset.name) nombre.value = this.dataset.name;
      this.q('[data-nombre-label]').textContent = pro ? 'Nombre de tu empresa' : '¿Cómo te llamas?';
      this.q('[data-nombre-input]').placeholder = pro ? 'Automóviles García S.L.' : 'Tu nombre';
      this.q('[data-nombre-input]').autocomplete = pro ? 'organization' : 'given-name';
      this.q('[data-desc-label]').innerHTML = `${pro ? 'Sobre tu empresa' : 'Sobre ti'} <small>(opcional)</small>`;
      this.q('[data-desc-input]').placeholder = pro
        ? 'Unas líneas: a qué os dedicáis, desde cuándo, dónde estáis…'
        : 'Unas líneas sobre ti: qué te gusta, desde cuándo te mueves en este mundo…';
    }

    /* Si ya tiene perfil de vendedor, se rellena «¿Quién eres?» con él */
    async cargarPerfil() {
      try {
        const d = await (await this.motor('perfil')).json();
        if (!d.ok || !d.perfil) return;
        this.perfil = d.perfil;
        const f = this.form;
        const b = store.get();
        // Lo que ya escribió en este borrador (o lo de su anuncio, si lo está editando) manda
        if (!this.editar && !(b?.campos?.vendedor_nombre)) f.vendedor_nombre.value = d.perfil.nombre || f.vendedor_nombre.value;
        if (!this.editar && !(b?.campos?.vendedor_tipo)) [...f.vendedor_tipo].forEach((r) => { r.checked = r.value === d.perfil.tipo; });
        if (!(b?.campos?.descripcion_perfil)) f.descripcion_perfil.value = d.perfil.descripcion || '';
        if (!this.editar) this.q('[data-perfil-hola]').textContent = `Hola de nuevo, ${d.perfil.nombre}. Revisa que esté todo bien: es lo que se ve en tu anuncio y en tu perfil.`;
        this.quien();
      } catch (e) { /* sin perfil: lo crea al enviar */ }
    }

    /* Guarda «¿Quién eres?» como su perfil de vendedor (sin tocar su foto) */
    async guardarPerfil() {
      const f = this.form;
      try {
        await this.post('perfil', { nombre: f.vendedor_nombre.value, tipo: f.vendedor_tipo.value || 'particular', descripcion: f.descripcion_perfil.value, foto: this.perfil?.ruta_foto || '' });
      } catch (e) { /* no es imprescindible */ }
    }

    /* Editar: el formulario con lo que ya tiene publicado (o los cambios que tiene por revisar) */
    rellenarEdicion(a) {
      const f = this.form;
      [...f.elements.tipo].forEach((r) => { r.checked = r.value === a.tipo; });
      f.titulo.value = a.titulo || '';
      f.precio_consultar.checked = !a.precio;
      f.precio.value = a.precio ? Number(a.precio).toLocaleString('es-ES') : '';
      f.precio.disabled = f.precio_consultar.checked;
      ['ubicacion', 'resumen', 'historia', 'mecanica', 'vendedor_nombre', 'telefono'].forEach((k) => { f.elements[k].value = a[k] || ''; });
      [...f.elements.vendedor_tipo].forEach((r) => { r.checked = r.value === a.vendedor_tipo; });
      f.acepta_telefono.checked = true;
      f.condiciones.checked = true;
      // La ficha: lo que encaja con los campos del tipo va a su sitio; el resto, a «otros datos»
      const campos = (SPECS[a.tipo] || []).map(([label]) => label);
      this.specsGuardadas = {};
      const otros = [];
      (a.ficha || []).forEach(([k, v]) => {
        if (campos.includes(k)) this.specsGuardadas[k] = v;
        else otros.push(k === 'Equipamiento' ? v : `${k}: ${v}`);
      });
      f.otros.value = otros.join('\n');
      this.qa('[data-spec]').forEach((el) => { el.value = ''; });
      this.photos = (a.fotos || []).map((ruta, i) => ({ ruta, url: (a.fotos_url || [])[i] }));
    }

    /* Dictar con la voz (Chrome, Safari, Edge): lo que se dice se va escribiendo en el campo, sin borrar lo que había.
       Sin soporte, el botón no sale y queda el micrófono del teclado del móvil. */
    voz() {
      const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
      const tip = this.q('[data-voice-tip]');
      if (!SR) { if (tip) tip.hidden = true; return; }
      let rec = null;
      let activo = null;
      const parar = () => { if (rec) { try { rec.stop(); } catch (e) { /* ya parado */ } } };
      this.qa('[data-mic]').forEach((btn) => {
        btn.hidden = false;
        btn.addEventListener('click', () => {
          if (activo === btn) { parar(); return; }
          parar();
          const campo = this.form.elements[btn.dataset.mic];
          const base = campo.value.replace(/\s+$/, '');
          const sep = (texto) => (texto ? (btn.dataset.mic === 'otros' ? '\n' : ' ') : '');
          let dicho = '';
          rec = new SR();
          rec.lang = 'es-ES';
          rec.continuous = true;
          rec.interimResults = true;
          rec.onresult = (ev) => {
            let provisional = '';
            for (let i = ev.resultIndex; i < ev.results.length; i += 1) {
              const t = ev.results[i][0].transcript.trim();
              if (ev.results[i].isFinal) {
                const frase = t.charAt(0).toUpperCase() + t.slice(1);
                dicho += (dicho ? (btn.dataset.mic === 'otros' ? '\n' : '. ') : '') + frase;
              } else provisional += ` ${t}`;
            }
            const todo = (dicho + provisional).replace(/\.\s*\./g, '.').trim();
            campo.value = base + sep(base && todo) + todo;
            campo.dispatchEvent(new Event('input', { bubbles: true }));
          };
          const fin = () => {
            btn.classList.remove('is-on');
            btn.querySelector('[data-mic-label]').textContent = 'Dictar';
            if (dicho && !/[.!?]$/.test(campo.value) && btn.dataset.mic !== 'otros') { campo.value += '.'; campo.dispatchEvent(new Event('input', { bubbles: true })); }
            if (activo === btn) { activo = null; rec = null; }
          };
          rec.onend = fin;
          rec.onerror = (ev) => { if (ev.error === 'not-allowed') this.error('Para dictar, permite el micrófono en tu navegador.'); fin(); };
          activo = btn;
          btn.classList.add('is-on');
          btn.querySelector('[data-mic-label]').textContent = 'Escuchando… toca para parar';
          try { rec.start(); } catch (e) { fin(); }
        });
      });
    }

    /* La ficha técnica según el tipo */
    tipo() {
      const f = this.form;
      const t = f.tipo.value || 'coche';
      const caja = this.q('[data-specs]');
      const antes = { ...(this.specsGuardadas || {}), ...this.leerSpecs(true) };
      caja.innerHTML = '';
      (SPECS[t] || []).forEach(([label, kind, ph, suf]) => {
        const l = document.createElement('label');
        l.className = 'pb__f';
        const span = document.createElement('span');
        span.textContent = label + (suf ? ` (${suf.trim()})` : '');
        l.append(span);
        let el;
        if (Array.isArray(kind)) {
          el = document.createElement('select');
          el.append(new Option('—', ''));
          kind.forEach((o) => el.append(new Option(o, o)));
        } else {
          el = document.createElement('input');
          el.inputMode = kind === 'number' ? 'numeric' : 'text';
          el.placeholder = ph || '';
          el.maxLength = 80;
        }
        el.dataset.spec = label;
        if (suf) el.dataset.suf = suf;
        if (antes[label]) el.value = antes[label];
        l.append(el);
        caja.append(l);
      });
      // Textos de ejemplo según el tipo
      this.qa('[data-ph-coche]').forEach((el) => { el.placeholder = el.dataset[`ph${t[0].toUpperCase()}${t.slice(1)}`] || el.placeholder; });
      const mec = this.q('[data-mec-label]');
      if (mec) mec.textContent = t === 'casa' ? 'Estado y reformas' : 'Descripción mecánica y estado';
    }

    leerSpecs(crudo = false) {
      const out = {};
      this.qa('[data-spec]').forEach((el) => { if (el.value.trim()) out[el.dataset.spec] = el.value.trim(); });
      if (crudo) return out;
      const ficha = this.qa('[data-spec]').filter((el) => el.value.trim()).map((el) => {
        let v = el.value.trim();
        if (el.inputMode === 'numeric' && /^\d+$/.test(v) && Number(v) >= 10000) v = Number(v).toLocaleString('es-ES');
        return [el.dataset.spec, v + (el.dataset.suf && !v.endsWith(el.dataset.suf.trim()) ? el.dataset.suf : '')];
      });
      this.form.otros.value.split('\n').map((x) => x.trim()).filter(Boolean).forEach((x) => {
        const m = x.match(/^([^:]{2,40}):\s*(.+)$/);
        ficha.push(m ? [m[1].trim(), m[2].trim()] : ['Equipamiento', x]);
      });
      return ficha;
    }

    guardar() {
      if (this.editar) return;
      const f = this.form;
      const campos = {};
      ['tipo', 'titulo', 'precio', 'precio_consultar', 'ubicacion', 'resumen', 'otros', 'historia', 'mecanica', 'vendedor_tipo', 'vendedor_nombre', 'descripcion_perfil', 'telefono'].forEach((k) => {
        const el = f.elements[k];
        if (!el) return;
        campos[k] = el.type === 'checkbox' ? el.checked : el.value;
      });
      store.set({ campos, specs: this.leerSpecs(true) });
    }

    contar() {
      this.qa('[data-count-for]').forEach((el) => {
        const n = this.form.elements[el.dataset.countFor].value.trim().length;
        const min = Number(el.dataset.min) || 0;
        el.textContent = min && n < min ? `${n} / mínimo ${min} caracteres` : `${n} caracteres`;
      });
    }

    /* Pasos */
    ir(n, validar = true) {
      if (validar && n > this.step && !this.validar(this.step)) return;
      this.step = Math.max(0, Math.min(5, n));
      this.qa('[data-step]').forEach((s) => { s.hidden = Number(s.dataset.step) !== this.step; });
      this.qa('[data-step-dot]').forEach((d, i) => { d.classList.toggle('is-on', i === this.step); d.classList.toggle('is-done', i < this.step); });
      this.q('[data-progress]').style.width = `${((this.step + 1) / 6) * 100}%`;
      this.q('[data-back]').hidden = this.step === 0;
      this.q('[data-next]').hidden = this.step === 5;
      this.q('[data-send]').hidden = this.step !== 5;
      if (this.step === 5) this.vista();
      this.error('');
      if (validar) this.form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    validar(paso) {
      const f = this.form;
      const mal = (campo, el) => { this.error(MENSAJES[campo]); (el || f.elements[campo])?.closest?.('.pb__f')?.classList.add('is-bad'); (el || f.elements[campo])?.focus?.(); return false; };
      if (paso === 0) {
        if (!f.vendedor_tipo.value) return mal('vendedor_tipo');
        if (f.vendedor_nombre.value.trim().length < 2) return mal('vendedor_nombre');
        if (f.telefono.value.replace(/\D/g, '').length < 9) return mal('telefono');
        if (!f.acepta_telefono.checked) return mal('acepta_telefono');
      }
      if (paso === 1 && !f.tipo.value) return mal('tipo', f.querySelector('[name=tipo]'));
      if (paso === 2) {
        if (f.titulo.value.trim().length < 4) return mal('titulo');
        if (!f.precio_consultar.checked && !(Number(f.precio.value.replace(/\D/g, '')) > 0)) return mal('precio');
        if (f.ubicacion.value.trim().length < 2) return mal('ubicacion');
        if (f.resumen.value.trim().length < 20) return mal('resumen');
      }
      if (paso === 3 && this.leerSpecs().length < 3) return mal('ficha', this.q('[data-spec]'));
      if (paso === 4) {
        if (f.historia.value.trim().length < 150) return mal('historia');
        if (f.mecanica.value.trim().length < 40) return mal('mecanica');
      }
      if (paso === 5) {
        if (this.photos.length < this.min) { this.error(`Sube al menos ${this.min} fotos (llevas ${this.photos.length}).`); return false; }
        if (!f.condiciones.checked) return mal('condiciones');
      }
      return true;
    }

    error(t) { const e = this.q('[data-error]'); e.textContent = t; e.hidden = !t; }

    /* Fotos */
    async anadir(files) {
      const imgs = files.filter((f) => /^image\//.test(f.type) || /\.(heic|heif)$/i.test(f.name)).slice(0, MAX - this.photos.length);
      if (files.length && !imgs.length) this.error('Solo fotos (JPG, PNG, WebP o HEIC).');
      for (const file of imgs) {
        try { this.photos.push(await reducir(file)); } catch (e) { this.error(`No hemos podido leer «${file.name}». Prueba a guardarla como JPG.`); }
        this.fotos();
      }
      if (this.photos.length >= MAX) this.error(`Máximo ${MAX} fotos.`);
    }

    /* «Así se verá tu anuncio»: portada, precio, título y dónde */
    vista() {
      const box = this.q('[data-preview]');
      if (!box) return;
      const f = this.form;
      box.hidden = this.photos.length === 0;
      if (box.hidden) return;
      this.q('[data-pv-img]').src = this.photos[0].url;
      const n = Number(f.precio.value.replace(/\D/g, ''));
      this.q('[data-pv-price]').textContent = f.precio_consultar.checked || !n ? 'Precio a consultar' : `${n.toLocaleString('es-ES')} €`;
      this.q('[data-pv-title]').textContent = f.titulo.value || 'Tu anuncio';
      this.q('[data-pv-meta]').textContent = f.ubicacion.value;
    }

    fotos() {
      const ul = this.q('[data-photos]');
      ul.innerHTML = '';
      this.photos.forEach((p, i) => {
        const li = document.createElement('li');
        li.className = 'pb__photo';
        li.innerHTML = `<img src="${p.url}" alt="Foto ${i + 1}">${i === 0 ? '<span class="pb__photo-cover">Portada</span>' : ''}<span class="pb__photo-tools">${i ? '<button type="button" data-cover aria-label="Usar de portada">★</button>' : ''}<button type="button" data-del aria-label="Quitar foto">✕</button></span>`;
        li.querySelector('[data-del]').addEventListener('click', () => { if (p.blob) URL.revokeObjectURL(p.url); this.photos.splice(i, 1); this.fotos(); });
        li.querySelector('[data-cover]')?.addEventListener('click', () => { this.photos.unshift(...this.photos.splice(i, 1)); this.fotos(); });
        ul.append(li);
      });
      const n = this.photos.length;
      this.q('[data-photo-count]').textContent = n ? `${n} ${n === 1 ? 'foto' : 'fotos'}${n < this.min ? ` · faltan ${this.min - n}` : ' ✓'}` : '';
      this.vista();
    }

    /* Enviar: permisos → subir fotos → solicitud */
    async enviar() {
      if (!this.validar(5)) return;
      for (let p = 0; p < 5; p++) if (!this.validar(p)) return this.ir(p, false);
      const btn = this.q('[data-send]');
      btn.disabled = true;
      const f = this.form;
      const datos = {
        tipo: f.tipo.value, titulo: f.titulo.value, precio: f.precio_consultar.checked ? '' : f.precio.value.replace(/\D/g, ''), precio_consultar: f.precio_consultar.checked,
        ubicacion: f.ubicacion.value, resumen: f.resumen.value, historia: f.historia.value, mecanica: f.mecanica.value, ficha: this.leerSpecs(),
        fotos: [], vendedor_tipo: f.vendedor_tipo.value || 'particular', vendedor_nombre: f.vendedor_nombre.value, telefono: f.telefono.value, email: this.dataset.email || '',
        acepta_telefono: f.acepta_telefono.checked, condiciones: f.condiciones.checked
      };
      let motor = { ok: false };
      let enlaces = [];
      try {
        // 1 · Al motor: fotos a Supabase y la solicitud al panel
        // Solo se suben las fotos nuevas (al editar, las que ya estaban se quedan donde están)
        const nuevas = this.photos.filter((p) => p.blob);
        btn.textContent = 'Preparando las fotos…';
        const perm = nuevas.length ? await this.post('anuncio/fotos', { tipos: nuevas.map(() => 'image/jpeg'), editar: Boolean(this.editar) }) : { ok: true, subidas: [] };
        if (!perm.ok) throw Object.assign(new Error(perm.error), { campo: perm.error, detalle: perm.detalle });
        const items = this.qa('.pb__photo');
        let hechas = 0;
        const subir = async (k) => {
          const foto = nuevas[k];
          const i = this.photos.indexOf(foto);
          items[i]?.classList.add('is-up');
          const r = await fetch(perm.subidas[k].url, { method: 'PUT', headers: { 'Content-Type': 'image/jpeg', 'x-upsert': 'false' }, body: foto.blob, signal: tiempo(60000) })
            .catch((e) => { throw Object.assign(new Error('subida'), { campo: 'subida', detalle: porTiempo(e) ? 'fotos-sin-respuesta' : 'fotos-red' }); });
          if (!r.ok) throw Object.assign(new Error('subida'), { campo: 'subida', detalle: `fotos-${r.status}` });
          items[i]?.classList.remove('is-up');
          foto.ruta = perm.subidas[k].ruta;
          foto.publica = perm.subidas[k].url.replace('/object/upload/sign/', '/object/public/').split('?')[0];
          hechas += 1;
          btn.textContent = `Subiendo fotos ${hechas}/${nuevas.length}…`;
        };
        const cola = [...nuevas.keys()];
        await Promise.all(Array.from({ length: 3 }, async () => { while (cola.length) await subir(cola.shift()); }));
        enlaces = this.photos.map((p) => p.publica || p.url);
        btn.textContent = this.editar ? 'Guardando…' : 'Enviando…';
        datos.fotos = this.photos.map((p) => p.ruta);
        const r = await this.post(this.editar ? 'anuncio/editar' : 'anuncio', this.editar ? { ...datos, id: this.editar.id } : datos);
        if (!r.ok) throw Object.assign(new Error(r.error), { campo: r.campo || r.error, detalle: r.detalle });
        motor = { ok: true, revision: Boolean(r.revision), de_pago: Boolean(r.de_pago), precio: Number(r.precio) || 0 };
        await this.guardarPerfil();
      } catch (e) {
        motor = { ok: false, campo: e.campo || 'red', detalle: e.detalle || '' };
      }

      // Editando: o se guarda en el motor o se dice qué ha pasado (sin envío de reserva)
      if (this.editar) {
        btn.disabled = false;
        btn.textContent = 'Guardar cambios';
        if (!motor.ok) {
          if (PASO_DE[motor.campo] !== undefined && PASO_DE[motor.campo] !== this.step) this.ir(PASO_DE[motor.campo], false);
          this.error((MENSAJES[motor.campo] || MENSAJES.red) + (motor.detalle ? ` (${motor.detalle})` : ''));
          return;
        }
        this.q('[data-done-title]').textContent = motor.revision ? '¡Cambios enviados!' : '¡Cambios guardados!';
        this.q('[data-done-text]').textContent = motor.revision
          ? 'Revisamos tus cambios y, en cuanto estén aprobados, se verán en tu anuncio. Te avisamos por email.'
          : 'Tu anuncio está actualizado. Lo seguimos revisando y te escribimos en menos de 48 horas.';
        this.view('done');
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      // Lo que tiene que corregir quien anuncia (un dato, ya tiene uno, la sesión): se le dice y no se envía nada
      if (!motor.ok && (PASO_DE[motor.campo] !== undefined || ['limite', 'login', 'tipo', 'clave'].includes(motor.campo))) {
        btn.disabled = false;
        btn.textContent = 'Enviar mi anuncio';
        if (PASO_DE[motor.campo] !== undefined && PASO_DE[motor.campo] !== this.step) this.ir(PASO_DE[motor.campo], false);
        this.error(MENSAJES[motor.campo] || MENSAJES.red);
        return;
      }

      // 2 · Aviso al equipo por correo (formulario de contacto de Shopify), pase lo que pase con el motor.
      //     Si el motor no lo recibió, se envía como un formulario normal (pasa la protección antispam de Shopify,
      //     que puede pedir el «no soy un robot») y se vuelve a esta página con el anuncio recibido.
      btn.textContent = 'Enviando…';
      if (!motor.ok) {
        const contacto = this.rellenar(datos, motor, enlaces);
        // Como un clic en «Enviar»: así Shopify le pone su «no soy un robot» (con .submit() falta y da «Missing CAPTCHA token»)
        if (typeof contacto.requestSubmit === 'function') contacto.requestSubmit();
        else contacto.querySelector('button[type="submit"]').click();
        // Si la página no cambia en unos segundos (Shopify no lo deja enviar), se avisa y se puede volver a intentar
        setTimeout(() => {
          if (!this.isConnected || document.visibilityState === 'hidden') return;
          btn.disabled = false;
          btn.textContent = 'Enviar mi anuncio';
          this.error(MENSAJES.atasco + (motor.detalle ? ` (${motor.detalle})` : ''));
        }, 12000);
        return;
      }
      const correo = await this.avisar(datos, motor, enlaces);
      btn.disabled = false;
      btn.textContent = 'Enviar mi anuncio';
      if (motor.ok || correo) {
        store.clear();
        if (!motor.ok) this.q('[data-done-text]').textContent = 'Tenemos tu anuncio. Te escribimos por WhatsApp en menos de 48 horas para pedirte las fotos y publicarlo.';
        else if (motor.de_pago) this.q('[data-done-text]').textContent = `Lo revisamos en menos de 48 horas. Como ya tienes otro anuncio, este cuesta ${motor.precio ? `${this.euros(motor.precio)} al mes` : 'una cuota al mes'}: al publicarlo te mandamos por email el enlace para pagarlo con tarjeta (se renueva solo y lo cancelas cuando quieras).`;
        this.view('done');
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        document.dispatchEvent(new CustomEvent('sidonia:anuncio-enviado', { detail: { tipo: datos.tipo } }));
        return;
      }
      const detalle = motor.detalle ? ` (${motor.detalle})` : '';
      this.error((MENSAJES[motor.campo] || MENSAJES.red) + detalle);
    }

    /* El correo al equipo: todo el anuncio en texto, con los enlaces a las fotos si se subieron */
    async avisar(d, motor, enlaces) {
      const form = this.rellenar(d, motor, enlaces);
      if (!form) return false;
      try {
        const r = await fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', signal: tiempo(10000) });
        return r.ok && !/challenge/.test(r.url);
      } catch (e) {
        return false;
      }
    }

    rellenar(d, motor, enlaces) {
      const form = this.querySelector('form.pb__contact');
      if (!form) return null;
      const precio = d.precio ? `${Number(d.precio).toLocaleString('es-ES')} €` : 'A consultar';
      const ficha = (d.ficha || []).map(([k, v]) => `· ${k}: ${v}`).join('\n');
      const texto = [
        `NUEVO ANUNCIO GRATIS (${motor.ok ? 'está en el panel para revisarlo' : `el panel no lo ha recibido${motor.detalle ? ` · ${motor.detalle}` : ''}: pídele las fotos por WhatsApp`})`,
        '',
        `${d.titulo} — ${precio}`,
        `${({ coche: 'Coche', moto: 'Moto', barco: 'Barco', casa: 'Casa' })[d.tipo] || d.tipo} · ${d.ubicacion}`,
        `Vende: ${d.vendedor_nombre} (${d.vendedor_tipo}) · Tel. ${d.telefono} · ${d.email || 'sin email'}`,
        `WhatsApp: https://wa.me/${String(d.telefono).replace(/\D/g, '').replace(/^(?=[6789]\d{8}$)/, '34')}`,
        '',
        'DESCRIPCIÓN', d.resumen, '',
        'HISTORIA', d.historia, '',
        'MECÁNICA Y ESTADO', d.mecanica, '',
        'FICHA TÉCNICA', ficha, '',
        `FOTOS (${this.photos.length})`, enlaces.length ? enlaces.join('\n') : 'No se han podido subir: pídeselas por WhatsApp.'
      ].join('\n');
      form.querySelector('[name="contact[body]"]').value = texto.slice(0, 18000);
      if (!form.querySelector('[name="contact[email]"]').value && d.email) form.querySelector('[name="contact[email]"]').value = d.email;
      return form;
    }

    // El motor responde en el proxy de la app (/apps/sidonia). Si ahí no hay nada (la app de Shopify aún tiene la
    // dirección antigua), se prueban las otras. Solo se repite con un 404, así que un anuncio nunca se envía dos veces.
    async motor(ruta, init = {}) {
      const opts = () => ({ credentials: 'same-origin', signal: tiempo(15000), ...init, headers: { Accept: 'application/json', ...(init.headers || {}) } });
      const quien = this.dataset.quien ? `${ruta.includes('?') ? '&' : '?'}${this.dataset.quien}` : '';
      // 1 · Directo al motor (Vercel), sin el proxy de Shopify. Las POST llevan JSON, así que el navegador pregunta antes
      //     (CORS) y, si no le dejan, no se envía nada: se puede probar por el proxy sin duplicar el anuncio.
      const directo = (this.dataset.directo || '').replace(/\/+$/, '');
      if (directo && quien) {
        try {
          const r = await fetch(`${directo}/tienda/api/${ruta}${quien}`, { ...opts(), credentials: 'omit' });
          if (r.status !== 404) return r;
        } catch (e) {
          if (porTiempo(e)) throw e;
        }
      }
      // 2 · Por el proxy de la app
      let r = await fetch(`${this.base}/api/${ruta}${quien}`, opts());
      for (const otra of OTRAS) {
        if (r.status !== 404 || otra === this.base) continue;
        const r2 = await fetch(`${otra}/api/${ruta}${quien}`, opts()).catch(() => null);
        if (r2 && r2.status !== 404) {
          this.base = otra;
          r = r2;
        }
      }
      return r;
    }

    async post(ruta, body) {
      let r;
      try {
        r = await this.motor(ruta, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      } catch (e) {
        return { ok: false, error: 'red', detalle: porTiempo(e) ? 'sin-respuesta' : 'red' };
      }
      const d = await r.json().catch(() => null);
      if (d) return d;
      // Sin respuesta del motor: 404 = el servidor aún no tiene los anuncios; otro = falla el servidor
      return { ok: false, error: r.status === 404 ? 'motor' : 'servidor', detalle: `http-${r.status}` };
    }
  }

  customElements.define('sidonia-publish', SidoniaPublish);
})();
